import hook from '../../scripts/utilities/hook';
import moveTo from '../../scripts/utilities/moveTo';

const MOVETO_SELECTOR = hook('js-moveto');

const movetoElements = document.querySelectorAll(MOVETO_SELECTOR);

movetoElements.forEach(movetoElement => {
  movetoElement.addEventListener('click', event => {
    event.preventDefault();

    const target = event.target.dataset.movetoTarget;
    const targetElement = document.querySelector(target);

    if (event.target.dataset.movetoTolarence) {
      const tolarence = event.target.dataset.movetoTolarence;
      moveTo(targetElement, tolarence);
    } else {
      moveTo(targetElement, 0);
    }
  });
});
